/*
検索の切り替え
 */
var SearchToggle = function() {
    this.$body = $('body');
    this.$searchBtn = $('#js-searchBtn');
    this.$search = $('#js-search');
    this.$header = $('#js-globalHeader');
    this.isOpen = false;
    this.scrollToggle = require('./scrollToggle');
};

SearchToggle.prototype = {
    init: function() {
        var _this = this;
        _this.$searchBtn.on('click', function(e) {
            e.preventDefault();
            if(_this.isOpen){
                _this.$body.css({'height': 'auto'});
                _this.$searchBtn.removeClass('is-search-open');
                _this.$search.removeClass('is-search-open');
                _this.$header.removeClass('is-search-open');
                _this.isOpen = false;
                _this.scrollToggle.allow();
            }else{
                _this.$body.css({'height': _this.$search.height() + 'px'});
                _this.$searchBtn.addClass('is-search-open');
                _this.$search.addClass('is-search-open');
                _this.$header.addClass('is-search-open');
                _this.isOpen = true;
                _this.scrollToggle.forbid();
            }
        });
    }
};

module.exports = SearchToggle;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/SearchToggle.js
 **/